import { RECEIVE_ADDONS, TOGGLE_ADDON_DISPLAY } from '../../actions/addons';

export const initialState = {
  addons: [],
  addonsDisplay: {},
};

export default (
  state = initialState,
  { type, data: { addons, addonsDisplay, option } = {} } = {},
) => {
  switch (type) {
    case RECEIVE_ADDONS:
      return {
        ...state,
        addons,
        addonsDisplay,
      };

    case TOGGLE_ADDON_DISPLAY:
      return {
        ...state,
        addonsDisplay: {
          ...state.addonsDisplay,
          [option]: !state.addonsDisplay[option],
        },
      };

    default:
      return state;
  }
};
